var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"publish",staticClass:"collection"},[_vm._l((_vm.list),function(item){return _c('MessageItem',_vm._b({key:item.id},'MessageItem',item,false))}),_c('van-loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loading",attrs:{"size":"24px"}},[_vm._v("加载中...")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }